export const OwnerShipKey = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EQUITY_SHARES: 'equityShare',
  OP_CONTROL: 'operationalControl',
  FIN_CONTROL: 'financialControl',
  HOLDING_NAME: 'name',
  HOLDING_TYPE: 'type',
  HOLDING_PERCENT: 'sharesPercentage',
  TELEPHONE: 'mobile',
  EMAIL: 'email',
  GST: 'taxIdentityNumber',
  CREATE_USER: 'createUser'
};

export const OwnerShipLabel = {
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  EQUITY_SHARES: 'Equity Share',
  OP_CONTROL: 'Operational Control',
  FIN_CONTROL: 'Financial Control',
  HOLDING_NAME: 'Holding Company Name',
  HOLDING_TYPE: 'Holding Type',
  HOLDING_PERCENT: 'Holding Percent',
  TELEPHONE: 'Mobile Number',
  EMAIL: 'Email ID',
  GST: 'GST Number',
  IS_USER_CREATION: 'Create Holding User'
};
